import { useState } from "react";


const useContainerForm = () => {
    const [isOpen, setIsOpen] = useState(true);
    const toggleAccordion = () => {
      setIsOpen(!isOpen);
    };
  return{
        isOpen,
        toggleAccordion
  }
}

export default useContainerForm